import {
  Box,
  Container,
  Accordion,
  Typography,
  IconButton,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Button,
} from "@mui/material";
import React, { useState } from "react";
import { ExpandMore } from "@mui/icons-material";
import { TravelAssistanceStyles } from "../Styles";
import { getMeaning } from "../../utils/localization";

const FAQLIST = {
  General: [
    { question: getMeaning("FAQ.GNQSONE"), answer: getMeaning("FAQ.GNANSONE") },
    { question: getMeaning("FAQ.GNQSTWO"), answer: getMeaning("FAQ.GNANSTWO") },
    { question: getMeaning("FAQ.GNQSTHR"), answer: getMeaning("FAQ.GNANSTHR") },
    { question: getMeaning("FAQ.GNQSFOR"), answer: getMeaning("FAQ.GNANSFOR") },
  ],
  "Travel Assistance": [
    { question: getMeaning("FAQ.TAQSONE"), answer: getMeaning("FAQ.TAANSONE") },
    { question: getMeaning("FAQ.TAQSTWO"), answer: getMeaning("FAQ.TAANSTWO") },
    { question: getMeaning("FAQ.TAQSTHR"), answer: getMeaning("FAQ.TAANSTHR") },
    { question: getMeaning("FAQ.TAQSFOR"), answer: getMeaning("FAQ.TAANSFOR") },
  ],

  "Roadside Assistance": [
    {
      question: getMeaning("FAQ.RAQSONE"),
      answer: getMeaning("FAQ.RAANSONE"),
      pointsOne: getMeaning("FAQ.RAPNTONE"),
      pointsTwo: getMeaning("FAQ.RAPNTTWO"),
      pointsThree: getMeaning("FAQ.RAPNTTHR"),
      pointsFour: getMeaning("FAQ.RAPNTFOR"),
      pointsSix: getMeaning("FAQ.RAPNTFVE"),
    },
    { question: getMeaning("FAQ.RAQSTWO"), answer: getMeaning("FAQ.RAANSTWO") },
    { question: getMeaning("FAQ.RAQSTHR"), answer: getMeaning("FAQ.RAANSTHR") },
  ],

  "Gadget Appliance Protection": [
    { question: getMeaning("FAQ.GAQSONE"), answer: getMeaning("FAQ.GAANSONE") },
    { question: getMeaning("FAQ.GAQSTWO"), answer: getMeaning("FAQ.GAANSTWO") },
    { question: getMeaning("FAQ.GAQSTHR"), answer: getMeaning("FAQ.GAANSTHR") },
  ],

  "Health & Wellness": [
    { question: getMeaning("FAQ.HWQSONE"), answer: getMeaning("FAQ.HWANSONE") },
    { question: getMeaning("FAQ.HWQSTWO"), answer: getMeaning("FAQ.HWANSTWO") },
    { question: getMeaning("FAQ.HWQSTHR"), answer: getMeaning("FAQ.HWANSTHR") },
  ],

  "Claims & Reimbursements": [
    { question: getMeaning("FAQ.CRQSONE"), answer: getMeaning("FAQ.CRANSONE") },
    { question: getMeaning("FAQ.CRQSTWO"), answer: getMeaning("FAQ.CRANSTWO") },
    { question: getMeaning("FAQ.CRQSTHR"), answer: getMeaning("FAQ.CRANSTHR") },
  ],
};

const Faqs = () => {
  const categories = Object.keys(FAQLIST);
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <Box m={10} sx={[TravelAssistanceStyles.MainBannerBox]}>
      <Container maxWidth="md" sx={{ py: 8 }}>
        {/* <Typography
          variant="subtitle1"
          fontStyle="italic"
          mb={4}
          sx={{ fontFamily: '"Poppins", serif' }}
        >
          “StatSync <strong>{getMeaning("FAQ.CMPLTTRNSFRM")}</strong>
          {getMeaning("FAQ.HWWEMNGE")}
        </Typography> */}

        <Box textAlign="center" mb={6}>
          <Box display="flex" justifyContent="center" alignItems="center">
            <IconButton size="small" color="primary">
              <img
                alt="faq"
                src={require("../../assets/icons/FAQ.png")}
                style={{ height: 50, width: 50 }}
              />
            </IconButton>

            <Typography
              variant="h4"
              color="primary"
              gutterBottom
              sx={{ fontFamily: '"Poppins", serif', fontWeight: 600 }}
            >
              {getMeaning("FAQ.FAQLBL")}
            </Typography>
          </Box>

          {/* <Tabs
            value={selectedTab}
            onChange={(e, newValue) => setSelectedTab(newValue)}
            textColor="primary"
            indicatorColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            sx={{ mb: 3 }}
          >
            {categories.map((category, index) => (
              <Tab
                sx={{ fontFamily: '"Poppins", serif' }}
                label={category}
                key={index}
              />
            ))}
          </Tabs> */}

          <Stack
            direction="row"
            spacing={2}
            flexWrap="wrap"
            rowGap={2}
            sx={{
              mt: 3,
              mb: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {categories.map((category, index) => (
              <Button
                key={index}
                variant={selectedTab === index ? "contained" : "outlined"}
                onClick={() => setSelectedTab(index)}
                sx={{ fontFamily: '"Poppins", serif' }}
              >
                {category}
              </Button>
            ))}
          </Stack>

          <Typography
            variant="h5"
            fontWeight="600"
            gutterBottom
            sx={{ fontFamily: '"Poppins", serif' }}
          >
            {getMeaning("FAQ.GTQSANS")}
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ fontFamily: '"Poppins", serif' }}
          >
            {getMeaning("FAQ.EVRYTHNGSTOKNW")}
          </Typography>
        </Box>

        <Box>
          {FAQLIST[categories[selectedTab]].map((item, idx) => (
            <Accordion key={idx} sx={{ marginTop: 2 }}>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography
                  fontWeight="medium"
                  sx={{ fontFamily: '"Poppins", serif' }}
                >
                  {idx + 1}. {item.question}
                </Typography>
              </AccordionSummary>

              <AccordionDetails>
                <Typography
                  color="text.secondary"
                  sx={{ fontFamily: '"Poppins", serif', textAlign: "left" }}
                >
                  {item.answer}
                </Typography>
              </AccordionDetails>

              {item.pointsOne && (
                <AccordionDetails>
                  <Typography
                    color="text.secondary"
                    sx={{ fontFamily: '"Poppins", serif', textAlign: "left" }}
                  >
                    {item.pointsOne}
                  </Typography>
                </AccordionDetails>
              )}

              {item.pointsTwo && (
                <AccordionDetails>
                  <Typography
                    color="text.secondary"
                    sx={{ fontFamily: '"Poppins", serif', textAlign: "left" }}
                  >
                    {item.pointsTwo}
                  </Typography>
                </AccordionDetails>
              )}

              {item.pointsThree && (
                <AccordionDetails>
                  <Typography
                    color="text.secondary"
                    sx={{ fontFamily: '"Poppins", serif', textAlign: "left" }}
                  >
                    {item.pointsThree}
                  </Typography>
                </AccordionDetails>
              )}

              {item.pointsFour && (
                <AccordionDetails>
                  <Typography
                    color="text.secondary"
                    sx={{ fontFamily: '"Poppins", serif', textAlign: "left" }}
                  >
                    {item.pointsFour}
                  </Typography>
                </AccordionDetails>
              )}

              {item.pointsFive && (
                <AccordionDetails>
                  <Typography
                    color="text.secondary"
                    sx={{ fontFamily: '"Poppins", serif', textAlign: "left" }}
                  >
                    {item.pointsFive}
                  </Typography>
                </AccordionDetails>
              )}
            </Accordion>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default Faqs;
